import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from 'react';
import { pathFor } from '../config/routes';

type PageLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  page: string;
  onNavigate: (page: string) => void;
  /** set to the current page id to mark this link with aria-current when it matches */
  currentPage?: string;
  children: ReactNode;
};

/**
 * A real link to a site page: it has an href (crawlable, opens in a new tab with Cmd/Ctrl
 * or middle-click) but a plain click navigates client-side without a reload.
 */
export function PageLink({ page, onNavigate, currentPage, onClick, children, ...rest }: PageLinkProps) {
  const handle = (e: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e);
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    onNavigate(page);
  };
  return (
    <a href={pathFor(page)} onClick={handle} aria-current={currentPage === page ? 'page' : undefined} {...rest}>
      {children}
    </a>
  );
}
